export { ReactComponent as GoogleIcon } from './googleIcon.svg';
export { ReactComponent as MicrosoftIcon } from './microsoftIcon.svg';
export { ReactComponent as AppleIcon } from './appleIcon.svg';
